<div class="container-fluid global-header">
  <div class="global-header__context" *ngIf="pageHeaderState?.title">
    <ng-container *ngIf="pageHeaderState.breadcrumbs?.length; else titleOnly">
      <div class="global-header__breadcrumb-row">
        <button
          *ngIf="pageHeaderState.showBack"
          type="button"
          class="global-header__back back-navigation-icon"
          title="Back"
          aria-label="Back"
          (click)="onPageHeaderBack()">
        </button>
        <app-bread-crumbs [breadCrumb]="pageHeaderState.breadcrumbs"></app-bread-crumbs>
      </div>
    </ng-container>
    <ng-template #titleOnly>
      <div class="global-header__title-row">
        <span class="global-header__title">{{ pageHeaderState.title }}</span>
      </div>
    </ng-template>
  </div>

  <div class="nav-right-menu collapse navbar-collapse global-header__actions">
    <div class="nav navbar-nav navbar-right">
      <div class="top-bar-item ausHeader" *ngIf="eventListOptions.length">
        <p-dropdown [options]="eventListOptions" styleClass="header-event-dropdown transperentDropdown"
          panelStyleClass="header-event-dropdown-panel" appendTo="body" [autoZIndex]="true" [baseZIndex]="1200"
          [(ngModel)]="selectedEvent" (onChange)="changeFilter($event)">
          <ng-template let-item pTemplate="selectedItem">
            <div class="header-event-selected flex align-items-center gap-2">
              <img class="header-event-selected__icon" [src]="getImageSrc(item.imageId)" (error)="onImageError($event)" />
              <span class="header-event-selected__label" [title]="item?.label">{{ item?.label }}</span>
            </div>
          </ng-template>
          <ng-template let-event pTemplate="item">
            <div class="header-event-item flex align-items-center gap-2">
              <img class="header-event-item__icon" [src]="getImageSrc(event.imageId)" (error)="onImageError($event)" />
              <span class="header-event-item__label" [title]="event.label">{{ event.label }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div class="top-bar-item notifications-bell" [title]="'label_notifications' | translate"
        (click)="getNotificationListAndToggle($event)">
        <a [ngClass]="unReadNotificatonsCount?'nav-notifications-icon-with-dot':'nav-notifications-icon'">
        </a>
      </div>

      <div class="profile-menu-button top-bar-item">
        <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
        <a (click)="menu.toggle($event)">
          <img class="user-photo" src="{{profileUrl}}" onerror="src='/assets/images/temp/default_profile.png'">
          {{userFullName}}
          <i class="fa fa-angle-down" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="hasShowNotificationBar" styleClass="notification-sidebar" position="right"
  appendTo="body" [modal]="true" [blockScroll]="true" [showCloseIcon]="true"
  [ariaCloseLabel]="'label_close' | translate">
  <ng-template pTemplate="header">
    <span class="notification-sidebar-title">{{ notificationLabel }}</span>
  </ng-template>

  <div class="notification-container">
    <app-notification-mg1 [notifications]="notifications" (loadMoreNotification)="loadMoreNotification()">
    </app-notification-mg1>
  </div>
</p-sidebar>

<p-dialog modal="true" styleClass="add-terms-popup edit-profile-popup-form" [(visible)]="changePasswordPopup"
  [contentStyle]="{'width':'600px'}" class="profilePopup" appendTo="body">
  <p-header translate>
    label_change_password
  </p-header>
  <app-change-password [(changePasswordPopup)]="changePasswordPopup"
    (isShowChangePassword)="onCancelChangePassword($event)"></app-change-password>
</p-dialog>

<p-dialog class="profilePopup" modal="true" styleClass="edit-profile-popup edit-profile-popup-form" position="center center"
  [(visible)]="editProfilePopup" [contentStyle]="{'overflow':'auto', 'max-height':'70vh'}" appendTo="body">
  <p-header>
    Edit Profile
  </p-header>
  <app-edit-profile [(editProfilePopup)]="editProfilePopup" (showProfilePopup)="onCancelEditProfile($event)">
  </app-edit-profile>
</p-dialog>

<p-confirmDialog
  header="Confirmation"
  icon="pi pi-info-circle"
  appendTo="body">
</p-confirmDialog>

<p-dialog
  [(visible)]="showEventChangeDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [dismissableMask]="false"
  appendTo="body"
  position="center"
  [style]="{ width: '28rem', maxWidth: '95vw' }"
  styleClass="event-change-dialog"
  (onHide)="onCancelEventChange()">

  <ng-template pTemplate="header">
    <div class="event-change-dialog__header">
      <span class="event-change-dialog__icon" aria-hidden="true">
        <i class="pi pi-exclamation-triangle"></i>
      </span>
      <span class="event-change-dialog__title">Confirm Event Change</span>
    </div>
  </ng-template>

  <div class="event-change-dialog__body">
    <p class="event-change-dialog__message">
      Changing the event will reload the admin portal.<br />
      Are you sure you want to continue?
    </p>
    <div class="event-change-dialog__banner">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>Any unsaved changes may be lost.</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="event-change-dialog__footer">
      <button
        pButton
        type="button"
        class="p-button-outlined event-change-dialog__cancel-btn"
        label="Cancel"
        (click)="onCancelEventChange()">
      </button>
      <button
        pButton
        type="button"
        class="event-change-dialog__confirm-btn"
        label="Yes, Continue"
        (click)="onConfirmEventChange()">
      </button>
    </div>
  </ng-template>
</p-dialog>